import BaseApi from './baseApi';
import IListStatusGoodsMovements from '../models/IListStatusGoodsMovements';
import IAuthentication from '../models/IAuthentication';
export default class ListStatusGoodsMovementsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetListStatusGoodsMovements() : Promise<IListStatusGoodsMovements[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listStatusGoodsMovement: IListStatusGoodsMovements[] = [];
            listStatusGoodsMovement = response.data as IListStatusGoodsMovements[];
            return listStatusGoodsMovement;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListStatusGoodsMovement(listStatusGoodsMovement: IListStatusGoodsMovements) : Promise<string> {
        const json = this.getJsonSave(listStatusGoodsMovement);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListStatusGoodsMovement(listStatusGoodsMovement: IListStatusGoodsMovements) : Promise<boolean> {
        const json = this.getJsonUpdate(listStatusGoodsMovement);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListStatusGoodsMovement(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListStatusGoodsMovements",
                "Item2": "id"
            }, {
                "Item1": "ListStatusGoodsMovements",
                "Item2": "name"
            }],
            "tables": [{
                "Item1": "ListStatusGoodsMovements"
            }],
            "conditions": [{
                "Item1": "ListStatusGoodsMovements",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "ListStatusGoodsMovements.name"
            }]
        };
        return json;
    }
    
    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusGoodsMovements",
            "conditions": [{
                "Item1": "ListStatusGoodsMovements",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listStatusGoodsMovement: IListStatusGoodsMovements) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusGoodsMovement.name
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusGoodsMovements"
        };
        return json;
    }

    private getJsonUpdate(listStatusGoodsMovement: IListStatusGoodsMovements) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listStatusGoodsMovement.name
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListStatusGoodsMovements",
            "keyvalue": listStatusGoodsMovement.id
        };
        return json;
    }
}
